module.exports = __webpack_public_path__ + "/login_ui/img/gi-51e90a70e3e98b18e0db19aa42673131.svg";